import { getAnalytics } from 'firebase/analytics';

import { initializeFirebase } from './initializeFirebase';

export const initializeFirebaseAnalytics = () => getAnalytics(initializeFirebase());
